export async function load({ url }) {
	return {
		pagePath: url.pathname
	};
}
